import { render, staticRenderFns } from "./studentModal.vue?vue&type=template&id=28b25c8c&"
import script from "./studentModal.vue?vue&type=script&lang=js&"
export * from "./studentModal.vue?vue&type=script&lang=js&"
import style0 from "./studentModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports